import React, { Component, useContext, useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { unmountComponentAtNode, render } from "react-dom";
import { SiHackthebox } from "react-icons/si";
import { RiFeedbackLine } from "react-icons/ri";
import RefreshOrderSummary from "./RefreshOrderSummary";
import { IoMdHome } from "react-icons/io";
import {
  BsCartX,
  BsArrowRight,
  BsTruck,
  BsCashCoin,
  BsDoorClosed,
  BsClockHistory,
  BsArrowReturnLeft,
  BsPeopleFill,
} from "react-icons/bs";

import {
  Navbar,
  Nav,
  Badge,
  OverlayTrigger,
  Popover,
  ListGroup,
  Dropdown,
  Container,
  Row,
  Col,
  Button,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import MainMenu from "./MainMenu";

import CartContext from "./CartContext";

import "../CSS/textanimation.css";

export default class NavigationMobile extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      storeId: "",
      showOverlay: false,
    };
  }

  handleOnMouseEnter = () => {
    this.setState({ showOverlay: true });
  };
  handleOnMouseLeave = () => {
    this.setState({ showOverlay: false });
  };

  GetMyStoreDetails = () => {
    var v1 = process.env.REACT_APP_API + "Consumers/GetMyStoreDetails/";
    fetch(process.env.REACT_APP_API + "Consumers/GetMyStoreDetails/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
          alert(
            "This Application is not active yet. Please contact your Vendor!"
          );
        } else {
          let expirydate = new Date(data.storeEnd);
          const diffTime = Math.abs(new Date() - expirydate);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          if (new Date(data.storeEnd) > new Date() == false) {
            alert(
              "Information: Store License has expired. Kindly contact our Support Team for Renewal!"
            );
            return;
          } else if (diffDays < 30) {
            alert(
              "Renewal Remainder! Store License will expire on " +
                this.context.GetInDateFormat(new Date(data.storeEnd)) +
                ". Kindly contact our Support Team for Renewal!"
            );
          }
          this.context.setStoreId(data.id);
          if (this.state.storeId != "") return;
          this.setState({ storeId: data.id }, () => {
            this.context.GetStore();
            this.context.GetStoreSettings();
            this.context.GetEcProductTypes();
            this.context.GetStoreTypes();
            this.context.GetPosUserRoles();
            this.context.GetMainCarousels(); //1-desktop 2-Mobile
            this.context.GetOrderStatusTypes();
            this.context.GetProductGroups();
            this.context.getMainCategories();
            this.context.getSubCategories();
            this.context.getBrands();
            this.context.GetAllProducts();
            this.context.GetMainMenus();
            this.context.GetTop5Ads();
            this.context.GetAllImageNames();
            this.context.GetStoreRoles();
            this.context.GetOrdersSummary();
            this.context.GetCustomerOrderPaymentStatusTypes();
            this.context.getTaxDetails();
            this.context.getThemes();
            this.context.getProductThemes();
            this.context.GetRestaturantTables();
            this.context.GetRestaurantTableOrdereStatus();
            this.context.GetManufacturingStatusTypes();
            this.context.GetRawMaterialsInventories();
            this.context.GetProductServiceStatusTypes();
            this.context.GetProductServiceTasksInventories();
            this.context.GetClientCertificates();
            this.context.GetClientLogos();
            this.context.GetClientTestimonials();
            this.context.GetVlogs();
            this.context.GetBlogs();
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        alert("GetMyStoreDetails fetch err:" + error);
      });
  };

  componentDidMount() {
    if (this.state.storeId == "") {
      this.GetMyStoreDetails();
    }
    // if (this.context.store.Id != undefined) {
    //   this.context.GetAllImageNames();
    // }
  }
  componentDidUpdate() {}

  render() {
    if (this.context.storeId === "") {
      return <Navigate to="/HomeMobileFront" />;
    }
    return (
      <>
        {this.context.userData.loginStatus == "active" ? (
          <>
            <RefreshOrderSummary></RefreshOrderSummary>
          </>
        ) : (
          <></>
        )}

        <Navbar
          className="shadow sticky-top py-3"
          variant="dark"
          style={{ zIndex: 1030 }}
        >
          <Container fluid className="px-2 d-flex align-items-center">
            <Nav className="d-flex align-items-center p-0">
              <Nav.Link
                as={Link}
                to="/HomeMobileFront"
                className="d-flex align-items-center text-dark bg-white"
              >
                <IoMdHome size={22} />
              </Nav.Link>
            </Nav>
            &nbsp;&nbsp;&nbsp;
            {/* Left: logo + version (vertically centered) */}
            <Nav className="d-flex align-items-center p-0">
              <Nav.Link
                as={Link}
                to="/HomeMobileFront"
                className="d-flex align-items-center border-0 p-0"
                style={{ textDecoration: "none" }}
              >
                <img
                  src={
                    this.context.store.storageBlobUrl +
                    this.context.store.storageBlobContainerName +
                    "/images/" +
                    this.context.storeSettings.storeLogoFileName +
                    this.context.store.storageSasToken
                  }
                  height="30"
                  alt="logo"
                  className="bg-white"
                  style={{ objectFit: "contain" }}
                />
              </Nav.Link>
            </Nav>
            {/* Right: user links (ms-auto pushes to end) */}
            <Nav className="ms-auto d-flex align-items-center">
              {/* Login icon link (hidden depending on hideSignupLink) */}
              <Nav.Link
                as={Link}
                to="/UserLogin"
                className="border-0 mx-2 p-1 text-center"
                hidden={this.context.userData.hideSignupLink}
                style={{ color: "white" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="currentColor"
                  className="bi bi-person-circle"
                  viewBox="0 0 16 16"
                >
                  <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                  <path
                    fillRule="evenodd"
                    d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                  />
                </svg>
              </Nav.Link>

              {/* User popover button (hidden when signup link shown) */}
              <OverlayTrigger
                show={this.state.showOverlay}
                key="bottom"
                placement="bottom"
                rootClose={false}
                overlay={
                  <Popover
                    id={`popover-positioned-bottom`}
                    onMouseEnter={this.handleOnMouseEnter}
                    onMouseLeave={this.handleOnMouseLeave}
                    className="bg-dark"
                  >
                    <Popover.Header as="h3"></Popover.Header>
                    <Popover.Body>
                      <UserMenu></UserMenu>
                    </Popover.Body>
                  </Popover>
                }
              >
                <Button
                  style={{ height: "30px", width: "160px" }}
                  variant="light"
                  size="sm"
                  className="m-0 p-0 d-flex align-items-center justify-content-center"
                  hidden={!this.context.userData.hideSignupLink}
                  onMouseEnter={this.handleOnMouseEnter}
                  onMouseLeave={this.handleOnMouseLeave}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-person-circle me-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                    <path
                      fillRule="evenodd"
                      d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                    />
                  </svg>
                  <small className="text-nowrap">
                    Hi&nbsp;{this.context.userData.emailId}
                  </small>
                </Button>
              </OverlayTrigger>
            </Nav>
          </Container>
        </Navbar>
      </>
    );
  }
}

class UserMenu extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <ListGroup variant="flush" className="fw-bold bg-dark">
          <ListGroup.Item
            as={Link}
            action
            variant="dark"
            to="/UserChangePassword"
          >
            Change Password
          </ListGroup.Item>

          <ListGroup.Item
            as={Link}
            action
            variant="dark"
            to="/home"
            onClick={(e) => {
              this.context.clearUserData();
            }}
          >
            Sign Out
          </ListGroup.Item>
        </ListGroup>
      </>
    );
  }
}
